import { select, takeLatest } from '@redux-saga/core/effects'
import { put } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IDataPointsConfig } from '../../configurations/store/configurations.types'
import { getDatapointsConfigSelector } from '../../configurations/selectors'
import { initialActionsList } from '../store/timeline.reducers'
import { setActionsList } from '../store/timeline.actions'
import { getTripInformationSelector } from '../../tripInformation/selectors'
import { ITripInformationState } from '../../tripInformation/store/tripInformation.types'
import { TripInformationConstants } from '../../tripInformation/store/tripInformation.constants'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { ITimelineState } from '../store/timeline.types'

export function* filterActionsListOptions() {
  const datapointsConfig: IDataPointsConfig = yield select(getDatapointsConfigSelector)
  const { DP_HIDE_FIELDS_BY_STAFF } = datapointsConfig
  const tripInformationState: ITripInformationState = yield select(getTripInformationSelector)
  const { staffingLevel } = tripInformationState
  const timelineState: ITimelineState = yield select(getPatientTimelineSelector)
  const { actionsList } = timelineState

  try {
    const alsActionNames = [
      'Drain',
      'Titrate',
      'Labs',
      'Ventilator',
      'Blood Product Administration',
      'Ventricular Assist Device',
    ]
    const blsActionNames = ['']

    let updatedActionsList = [...actionsList]

    if (DP_HIDE_FIELDS_BY_STAFF === 1) {
      if (staffingLevel && staffingLevel.isAls) {
        blsActionNames.forEach((actionName) => {
          if (updatedActionsList.findIndex((an) => an.name === actionName) !== -1) {
            updatedActionsList = updatedActionsList.filter((action) => action.name !== actionName)
          }
        })

        alsActionNames.forEach((actionName) => {
          if (updatedActionsList.findIndex((an) => an.name === actionName) === -1) {
            const procAction = initialActionsList.find((action) => action.name === actionName)
            if (procAction) updatedActionsList = [...updatedActionsList, procAction]
          }
        })

        if (staffingLevel.name === 'Critical Care') {
          if (updatedActionsList.findIndex((an) => an.name === 'Critical Care') === -1) {
            const procAction = initialActionsList.find((action) => action.name === 'Critical Care')
            if (procAction) updatedActionsList = [...updatedActionsList, procAction]
          }
        } else {
          updatedActionsList = updatedActionsList.filter((action) => action.name !== 'Critical Care')
        }
      } else if (staffingLevel && staffingLevel.isBls) {
        alsActionNames.forEach((actionName) => {
          if (updatedActionsList.findIndex((an) => an.name === actionName) !== -1) {
            updatedActionsList = updatedActionsList.filter((action) => action.name !== actionName)
          }
        })

        blsActionNames.forEach((actionName) => {
          if (updatedActionsList.findIndex((an) => an.name === actionName) === -1) {
            const procAction = initialActionsList.find((action) => action.name === actionName)
            if (procAction) updatedActionsList = [...updatedActionsList, procAction]
          }
        })

        updatedActionsList = updatedActionsList.filter((action) => action.name !== 'Critical Care')
      } else {
        alsActionNames.forEach((actionName) => {
          if (updatedActionsList.findIndex((an) => an.name === actionName) !== -1) {
            updatedActionsList = updatedActionsList.filter((action) => action.name !== actionName)
          }
        })
        blsActionNames.forEach((actionName) => {
          if (updatedActionsList.findIndex((an) => an.name === actionName) !== -1) {
            updatedActionsList = updatedActionsList.filter((action) => action.name !== actionName)
          }
        })

        updatedActionsList = updatedActionsList.filter((action) => action.name !== 'Critical Care')
      }
    } else {
      alsActionNames.forEach((actionName) => {
        if (updatedActionsList.findIndex((an) => an.name === actionName) === -1) {
          const procAction = initialActionsList.find((action) => action.name === actionName)
          if (procAction) updatedActionsList = [...updatedActionsList, procAction]
        }
      })
      blsActionNames.forEach((actionName) => {
        if (updatedActionsList.findIndex((an) => an.name === actionName) === -1) {
          const procAction = initialActionsList.find((action) => action.name === actionName)
          if (procAction) updatedActionsList = [...updatedActionsList, procAction]
        }
      })

      if (updatedActionsList.findIndex((an) => an.name === 'Critical Care') === -1) {
        const procAction = initialActionsList.find((action) => action.name === 'Critical Care')
        if (procAction) updatedActionsList = [...updatedActionsList, procAction]
      }
    }

    yield put(setActionsList(updatedActionsList))
  } catch (e) {
    yield put(throwPcrException(`filterActionsListOptions() error: ${e}`))
  }
}

export function* filterActionsListOptionsSaga() {
  yield takeLatest(
    [TripInformationConstants.SET_TRIP_INFORMATION, TripInformationConstants.SET_STAFFING_LEVEL],
    filterActionsListOptions
  )
}
